import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withTranslations } from 'react-utilities';
import { Loading } from 'react-style-guide';
import { translationConfig } from './translation.config';
import PlaceListsContainer from './containers/PlaceListsContainer';
import HomePage from '../../../ts/react/homePage/HomePage';
import bedev2Services from '../../../ts/react/common/services/bedev2Services';
import experimentConstants from '../../../ts/react/common/constants/experimentConstants';
import { THomepagePersonalizationVariation } from '../../../ts/react/common/types/experimentTypes';

const { layerNames, defaultValues } = experimentConstants;

function App({ translate }) {
  const [variation, setVariation] = useState(undefined);

  useEffect(() => {
    const fetchVariation = async () => {
      const data = await bedev2Services.getExperimentationValues(
        layerNames.homePage,
        defaultValues.homePage
      );
      setVariation(data.UseOmniRecommendation);
    };
    // eslint-disable-next-line no-void
    void fetchVariation();
  }, []);

  if (variation === THomepagePersonalizationVariation.Default) {
    return <PlaceListsContainer translate={translate} />;
  }
  if (variation === THomepagePersonalizationVariation.V2) {
    return <HomePage />;
  }
  return <Loading />;
}

App.propTypes = {
  translate: PropTypes.func.isRequired
};
export default withTranslations(App, translationConfig);
